'use client'

import { themeBackgroundMap, themeBorderColorMap } from '@mntn-dev/ui-theme'
import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { getTestProps } from '../../utils/testing.ts'
import { AlertIndicator } from './alert-indicator.tsx'
import { AlertMain } from './alert-main.tsx'
import { AlertSubtitle } from './alert-subtitle.tsx'
import { AlertTitle } from './alert-title.tsx'
import {
  AlertProvider,
  type UseAlertProps,
  type AlertType,
  useAlert,
} from './use-alert.ts'

type AlertProps = PropsWithChildren<
  UseAlertProps & {
    className?: string
  }
>

export const AlertComponent = ({
  children,
  className,
  ...props
}: AlertProps) => {
  const context = useAlert(props)

  const { dataTestId, dataTrackingId } = context
  return (
    <AlertProvider value={context}>
      <div
        className={cn(
          'flex gap-4 items-center w-full p-4 rounded-lg border',
          themeBorderColorMap.muted,
          themeBackgroundMap['container-secondary'],
          className
        )}
        {...getTestProps({ dataTestId, dataTrackingId })}
      >
        {children}
      </div>
    </AlertProvider>
  )
}

const AlertNamespace = Object.assign(AlertComponent, {
  Indicator: AlertIndicator,
  Main: AlertMain,
  Subtitle: AlertSubtitle,
  Title: AlertTitle,
})

export { AlertNamespace as Alert, type AlertProps, type AlertType }
